import React, { useEffect, useState } from 'react'
import PageTitle from '../../components/PageTitle'
import { useParams } from 'react-router-dom';
import { equipmentCertificateService } from '../../services/equipmentCertificateService';
import { idCardService } from '../../services/idCardService';

const EquimentCertificate = () => {
    const [cardNo, setCardNo] = useState("");
    const [search, setSearch] = useState("");
    const [data,setData]=useState(null);
    const [loading,setLoading]=useState(false);
    const [error,setError]=useState("");

    useEffect(() => {
       window.scrollTo(0, 0);
       console.log("test");
      }, []);
 const getAsync = async () => {
     try {
        setError("");
        if(!cardNo)
        {
            setError("Card No. is required.");
            return;
        }
        setLoading(true);
        var response= await idCardService.getAsync(cardNo);
           console.log(response);
        if(!response.isSuccess) 
        {
            setError(response.errors[0]|| "An error occured. Please Try Again later.");
            setData(null);
            return;
        }
        setData(response.value);
        clearSearch();
     } catch (error) {
        setError("An error occured. Please Try Again later.");
        console.log(error);
     }
     finally {
        setLoading(false);
     }
 }
 const clearSearch=()=>{
    setSearch("");
    setCardNo("");
 }
 const handleChange=(e)=>{
    setError("");
    var value=e.target.value.trim();
    setSearch(value);
    setCardNo(value);
 }

    
  return (
    <>
      <PageTitle title="Search" />
      <section className="contact-details pt-120 pb-120">
        <div className="container">
          <div>
            <div className="row g-5">
              <div className="col-lg-12 content-column">
                <div className="inner-column">
                  <form>
                    <div className="type-feild">
                      <i className="fa-light fa-file-certificate" />
                      <input
                        name="form_name"
                        className="required"
                        type="text"
                        value={search}
                        onChange={handleChange}
                        placeholder="Enter Card No."
                      />
                      <small className="text-danger">
                        {error ? error : ""}
                      </small>
                    </div>
                    {loading && (
                      <button className="btn-two" type="button">
                        <i className="fa-light fa-search" /> Search...
                      </button>
                    )}
                    {!loading && (
                      <button
                        className="btn-two"
                        type="button"
                        onClick={getAsync}
                      >
                        <i className="fa-light fa-search" /> Search
                      </button>
                    )}
                  </form>
                </div>
              </div>
            </div>
            {data && (
              <div className="row">
                <div className="col-lg-12">
                  <div className="container my-5">
                    <div className="card shadow border-0 rounded-4 overflow-hidden">
                      <div
                        className="card-header text-center text-white py-3"
                        style={{ background: "#173763" }}
                      >
                        <h3
                          className="mb-0 fw-bold text-uppercase"
                          style={{ letterSpacing: "3px", color: "#fff" }}
                        >
                          Card Details
                        </h3>
                      </div>

                      <div className="card-body p-0">
                        <div className="table-responsive">
                          <table className="table table-bordered table-striped mb-0 align-middle">
                            <tbody>
                              <tr>
                                <th
                                  className="bg-light px-4 py-3"
                                  style={{ width: "40%" }}
                                >
                                  Card No.
                                </th>
                                <td className="px-4 py-3">
                                  {data.cardNo}
                                </td>
                              </tr>

                              <tr>
                                <th className="bg-light px-4 py-3">
                                  Iqama No.
                                </th>
                                <td className="px-4 py-3">
                                  {data.iqamaNumber}
                                </td>
                              </tr>

                              <tr>
                                <th className="bg-light px-4 py-3">
                                  Operator Name
                                </th>
                                <td className="px-4 py-3">{data.operatorName}</td>
                              </tr>

                              <tr>
                                <th className="bg-light px-4 py-3">
                                  Company Name
                                </th>
                                <td className="px-4 py-3">
                                  {data.companyName}
                                </td>
                              </tr>

                             

                              <tr>
                                <th className="bg-light px-4 py-3">
                                  Inspection Date
                                </th>
                                <td className="px-4 py-3">
                                  {data.issueDate?.toDate()}
                                </td>
                              </tr>

                              <tr>
                                <th className="bg-light px-4 py-3">
                                  Remaining Period
                                </th>
                                <td className="px-4 py-3">
                                  {data.expiryDate.toRemaining()}
                                </td>
                              </tr>

                              <tr>
                                <th className="bg-light px-4 py-3">Due Date</th>
                                <td className="px-4 py-3">
                                  {data.expiryDate?.toDate()}
                                </td>
                              </tr>

                              <tr>
                                <th className="bg-light px-4 py-3">Trade</th>
                                <td className="px-4 py-3">
                                  {data.trade}
                                </td>
                              </tr>
                              <tr>
                                <th className="bg-light px-4 py-3">Status</th>
                                <td
                                  className="px-4 py-3"
                                  dangerouslySetInnerHTML={{
                                    __html: data.expiryDate.toStatus(),
                                  }}
                                ></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="row">
              <div className="col-xl-12 col-lg-12 mb-5 mb-lg-0">
                <div className="sec-title mb-40">
                  <p
                    className="text wow fadeInUp"
                    data-wow-delay="200ms"
                    data-wow-duration="1500ms"
                  >
                    <span className="text-danger">Disclaimer</span> : Pak Arab
                    Inspection LTD. CO provides services based on international
                    standards and industry best practices. Pak Arab Inspection
                    LTD. CO is not responsible for incidents, damages, or
                    operational failures resulting from improper equipment use,
                    unsafe practices, inadequate maintenance, or non-compliance
                    after service completion.
                  </p>
                  <p>
                    For inquiries:
                    <br />
                    <a href="mailto:info@paic-sa.com">info@paic-sa.com</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default EquimentCertificate